/** The modifier key label for this platform, used in every shortcut hint. */
export const MOD =
  typeof navigator !== 'undefined' && /Mac|iP(hone|ad|od)/.test(navigator.platform)
    ? 'Cmd'
    : 'Ctrl';
